import React from 'react';
import PropTypes from 'prop-types';

export const IconAuthMessage = ({ className }) => (
  <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16.0001" cy="16" r="10.4" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.7332 29.0667C23.097 29.0667 29.0666 23.0971 29.0666 15.7334C29.0666 8.36956 23.097 2.40002 15.7332 2.40002C8.36944 2.40002 2.3999 8.36956 2.3999 15.7334C2.3999 23.0971 8.36944 29.0667 15.7332 29.0667ZM14.6999 10C11.6623 10 9.1999 12.4625 9.1999 15.5V21.1126H17.0349C20.0725 21.1126 22.5349 18.6501 22.5349 15.6126V15.5C22.5349 12.4625 20.0725 10 17.0349 10H14.6999ZM12.1634 14.3216C12.1634 13.9806 12.4398 13.7042 12.7808 13.7042H18.9544C19.2953 13.7042 19.5717 13.9806 19.5717 14.3216C19.5717 14.6625 19.2953 14.939 18.9544 14.939H12.7808C12.4398 14.939 12.1634 14.6625 12.1634 14.3216ZM12.7808 16.1737C12.4398 16.1737 12.1634 16.4501 12.1634 16.7911C12.1634 17.1321 12.4398 17.4085 12.7808 17.4085H17.1023C17.4433 17.4085 17.7197 17.1321 17.7197 16.7911C17.7197 16.4501 17.4433 16.1737 17.1023 16.1737H12.7808Z" fill="url(#icon-auth-message-1)" />
  </svg>

);

IconAuthMessage.propTypes = {
  className: PropTypes.string,
};

IconAuthMessage.defaultProps = {
  className: '',
};
